import React from 'react'
import Navbar from '../layouts/Navbar'
import Footer from '../Footer'
import FloatingNavbar from '../FloatingNavbar'

const Switch = () => {
  return (
    <div>
      <Navbar />
      <FloatingNavbar />
      Switch 
      <Footer/>
    </div>
  )
}

export default Switch
